import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header>
      <div className="header">
        <div className="container">
          <div className="row">
            <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 logo_section">
              <div className="full">
                <div className="center-desk">
                  <div className="logo">
                    <Link to="/">
                      <img src="/images/logo.png" alt="Royal Nails Pro Logo" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-9 col-lg-9 col-md-9 col-sm-12 col-12">
              <nav className="navigation navbar navbar-expand-md navbar-dark">
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={toggleMenu}
                  aria-controls="navbarsExample04"
                  aria-expanded={isMenuOpen}
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon"></span>
                </button>
                <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="navbarsExample04">
                  <ul className="navbar-nav mr-auto">
                    <li className={`nav-item ${isActive('/')}`}>
                      <Link className="nav-link" to="/" onClick={closeMenu}>
                        Accueil
                      </Link>
                    </li>
                    <li className={`nav-item ${isActive('/about')}`}>
                      <Link className="nav-link" to="/about" onClick={closeMenu}>
                        À propos
                      </Link>
                    </li>
                    <li className={`nav-item ${isActive('/gallery')}`}>
                      <Link className="nav-link" to="/gallery" onClick={closeMenu}>
                        Nos activités
                      </Link>
                    </li>
                    <li className={`nav-item ${isActive('/services')}`}>
                      <Link className="nav-link" to="/services" onClick={closeMenu}>
                        Services
                      </Link>
                    </li>
                    <li className={`nav-item ${isActive('/contact')}`}>
                      <Link className="nav-link" to="/contact" onClick={closeMenu}>
                        Contact
                      </Link>
                    </li>
                    {/* Boutique - Temporarily disabled
                    <li className={`nav-item ${isActive('/shop')}`}>
                      <Link className="nav-link" to="/shop" onClick={closeMenu}>
                        Boutique
                      </Link>
                    </li>
                    */}
                  </ul>

                  {/* Language Links */}
                  <ul className="navbar-nav">
                    <li className="nav-item">
                      <a 
                        href="https://royalnailspro.ch" 
                        className="nav-link"
                        style={{ marginLeft: '10px' }}
                        onClick={closeMenu}
                      >
                        🇫🇷 Français
                      </a>
                    </li>
                    <li className="nav-item">
                      <a 
                        href="https://royalnailspro.com" 
                        className="nav-link"
                        onClick={closeMenu}
                      >
                        🌐 English
                      </a>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;

